module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAADgAAAACYjX/eAAAAi0lEQVQ4EcXSYQ5AMAwG0P5wBS7hZFzSIbgP/bJ1mWqqWKLJMlN960DUJnpmZlBdAw/YwmPksX/1gG0ZWnnGugRaPt0oGfvCxSauQbvYLYK6GPbHA2g5gt5iABERNIwlMqHykvXxH2MeWmN6I6lzZw1I15dfw1VUskYjH0uV20tBXx3TJokGTgD+Jw6B5i+JxFYoyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-right.png
// module id = uxUY
// module chunks = 129